import {
  USERS_DASHBOARD_ENABLE,
  DEMAND_OVERVIEW_ENABLE,
  PURCHASEORDERS_OVERVIEW_ENABLE,
} from '@/constants/featuresFlags';

export default {
  created() {
    this.usersDashboardEnable = USERS_DASHBOARD_ENABLE;
    this.demandOverviewEnable = DEMAND_OVERVIEW_ENABLE;
    this.purchaseOrdersOverviewEnable = PURCHASEORDERS_OVERVIEW_ENABLE;
  },
};
